import { render, staticRenderFns } from "./MontageOptions.vue?vue&type=template&id=23749b48&scoped=true"
import script from "./MontageOptions.vue?vue&type=script&lang=js"
export * from "./MontageOptions.vue?vue&type=script&lang=js"
import style0 from "./MontageOptions.vue?vue&type=style&index=0&id=23749b48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23749b48",
  null
  
)

export default component.exports